export default "__VITE_ASSET__U0vT0GWg__"